// extracted by mini-css-extract-plugin
export default {"hidden":"AuthForm_hidden__AkuNp","form":"AuthForm_form__63x-y"};